import { Typography } from '@mui/material';
import styled from 'styled-components';

interface QuestionContainerProps {
  $isMCQ: boolean;
}

const QuestionsContainer = styled.div<QuestionContainerProps>`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme, $isMCQ }) => ($isMCQ ? theme.spacing(1) : theme.spacing(5))};
`;

const QuestionsCard = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing(1)};
    border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
    border: 1.5px solid ${({ theme }) => theme.palette.backdrop.main};
    padding: ${({ theme }) => theme.spacing(4, 8)};
    position: relative;
`;

const SavingStatusContainer = styled.div`
    position: absolute;
    top: ${({ theme }) => theme.spacing(2)};
    right: ${({ theme }) => theme.spacing(4)};
`;

const MultipleChoiceContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
`;

const QuestionContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
`;

const QuestionLabel = styled(Typography)`
    && {
        font-size: 16px;
        margin-bottom: ${({ theme }) => theme.spacing(1)};
        position: relative;
    }
`;

const MultipleChoiceLabel = styled(Typography)`
    && {
        font-size: 16px;
        font-weight: bold;
        margin-right: ${({ theme }) => theme.spacing(2)};
        width: 24px;
    }
`;

const ButtonContainer = styled.div`
    margin-top: ${({ theme }) => theme.spacing(1)};
`;

const NavigatorContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing(2)};
`;

const Mark = styled(Typography)`
    && {
        font-size: 14px;
        color: ${({ theme }) => theme.palette.gray.main};
        position: absolute;
        left: -${({ theme }) => theme.spacing(6)};
        position: absolute;
        top: 50%;
        transform: translateY(-50%); 
    }
`;

const MultipleChocieSelectContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
`;

const AnalyticsContainer = styled.div`
    margin-top: ${({ theme }) => theme.spacing(1)};
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    width: 100%;
`;

export { AnalyticsContainer,
  QuestionContainer,
  Mark,
  QuestionsContainer,
  QuestionsCard,
  QuestionLabel,
  MultipleChoiceContainer,
  MultipleChoiceLabel,
  ButtonContainer,
  NavigatorContainer,
  SavingStatusContainer,
  MultipleChocieSelectContainer };
